import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BlockState } from '../types'

const initialState: BlockState = { currentBlock: 0, initialBlock: 0, timestamp: 0 }

export const blockSlice = createSlice({
  name: 'Block',
  initialState,
  reducers: {
    setBlock: (state, action: PayloadAction<any>) => {
      if (state.initialBlock === 0) {
        state.initialBlock = action.payload.number
      }
    
      state.currentBlock = action.payload.number
      state.timestamp = action.payload.timestamp
    },
  },
})

// Actions
export const { setBlock } = blockSlice.actions

export default blockSlice.reducer
